import * as React from 'react';
import { Modal, Spin, Icon } from 'antd';
import injectSheet from 'react-jss';
const styles = {
  modalCss: {
    height: 300,
  },
};
class CreateInquiryLoader extends React.PureComponent<any, any> {
  render() {
    const { classes, from } = this.props;
    return <Modal className={classes.modalClass}
      width={300}
      visible={this.props.visible}
      closable={false}
      footer={null}>
      <div style={{ height: 130, display: 'flex', flexDirection: 'column' }} >
        <Spin indicator={
          <Icon type="loading" style={{ fontSize: 40 }} />}
          size="large" style={{
            marginTop: '15%', marginBottom: '15px',
            display: 'flex', justifyContent: 'space-around',
          }} />
        <h3 style={{ display: 'flex', justifyContent: 'space-around' }}>
          {this.props.type ? 'Updating ' : 'Creating '}
          {from === 'SHIPMENT' ? 'Shipment' : 'Inquiry'}</h3>
      </div>
    </Modal>;
  }
}

export default injectSheet(styles)(CreateInquiryLoader);
